import {
createThirdwebClient
} from "thirdweb";
import {
  ThirdwebProvider,
  ConnectButton,
  darkTheme,
} from "thirdweb/react";
import {
  createWallet,
  walletConnect,
} from "thirdweb/wallets";

const client = createThirdwebClient({
  clientId: "33741bd1a260ce11cb2283c5939fbd55",
});

const wallets = [
  createWallet("io.metamask"),
  createWallet("com.coinbase.wallet"),
  walletConnect(),
  createWallet("com.trustwallet.app"),
  createWallet("io.zerion.wallet"),
  createWallet("me.rainbow"),
  createWallet("app.phantom"),
];

export default function App() {
  return (
    <ThirdwebProvider>
      <ConnectButton
        client={client}
        wallets={wallets}
        theme={darkTheme({
          colors: {
            accentText: "#33FF10",
            accentButtonBg: "#1a1a1a",
            modalBg: "#2a2a2a",
            dropdownBg: "#2a2a2a",
            borderColor: "#33FF10",
            separatorLine: "#1a1a1a",
            primaryText: "#33FF10",
            secondaryText: "#efefef",
            primaryButtonBg: "#4a4a4a",
            accentButtonText: "#ededef",
	    secondaryButtonText: "#33FF10",
            primaryButtonText: "#33FF10",
	    secondaryButtonHoverBg: "#4a4a4a",
          },
        })}
        connectButton={{ label: "CONNECT CLUBSWAP" }}
        connectModal={{
          size: "wide",
          title: "COSMIC WALLET",
          titleIcon:
            "https://www.cosmicclub.xyz/pics/cosmicnftlogo150.webp",
          welcomeScreen: {
            img: {
              src: "https://www.cosmicclub.xyz/pics/cosmicnftlogo.png",
              width: 200,
              height: 200,
            },
          },
          showThirdwebBranding: true,
        }}
      />
    </ThirdwebProvider>
  );
}
